"use strict";
/** consts for drawing tool */
Object.defineProperty(exports, "__esModule", { value: true });
exports.V_OFFSETS = exports.H_OFFSETS = exports.GROUP = exports.BITMAP = exports.TASK = exports.CLOUD = exports.RECTANGLE = exports.TEXT = exports.PATH = exports.CIRCLE = exports.DRAWING_TOOL_RECTANGLE = exports.DRAWING_TOOL_CLOUD = exports.DRAWING_TOOL_CIRCLE = exports.DRAWING_TOOL_LINK = exports.DRAWING_TOOL_PHOTO = exports.DRAWING_TOOL_TEXT = exports.DRAWING_TOOL_BRUSH = exports.DRAWING_TOOL_PENCIL = exports.DRAWING_TOOL_MARKER = exports.DRAWING_TOOL_NONE = exports.SELECT_TOOL_ATTACHMENT = exports.SELECT_TOOL_SIZE = exports.SELECT_TOOL_COLOR = exports.SELECT_TOOL_PAINT = exports.SELECT_TOOL_AREA = exports.SELECT_TOOL_PICK = exports.SELECT_TOOL_PAN = exports.SELECT_TOOL_NONE = exports.BG_TRANSPARENCY = exports.CURSOR_OFFSET = exports.BORDER_THICKNESS = exports.RECT_LINE_WIDTH = exports.LINE_WIDTH = exports.FONT_SIZE = exports.ICON_SIZE = exports.BUFFER_SIZE = exports.DEFAULT_COLOR = exports.DEBUGGING = void 0;
exports.DEBUGGING = false;
exports.DEFAULT_COLOR = '#e91e63';
exports.BUFFER_SIZE = 8000000;
exports.ICON_SIZE = 32;
exports.FONT_SIZE = 35;
exports.LINE_WIDTH = 2;
exports.RECT_LINE_WIDTH = 1;
exports.BORDER_THICKNESS = 1;
exports.CURSOR_OFFSET = 5;
exports.BG_TRANSPARENCY = 24;
exports.SELECT_TOOL_NONE = 'none';
exports.SELECT_TOOL_PAN = 'pan';
exports.SELECT_TOOL_PICK = 'pick';
exports.SELECT_TOOL_AREA = 'area';
exports.SELECT_TOOL_PAINT = 'paint';
exports.SELECT_TOOL_COLOR = 'color';
exports.SELECT_TOOL_SIZE = 'size';
exports.SELECT_TOOL_ATTACHMENT = 'attachment';
exports.DRAWING_TOOL_NONE = 'none';
exports.DRAWING_TOOL_MARKER = 'marker';
exports.DRAWING_TOOL_PENCIL = 'pencil';
exports.DRAWING_TOOL_BRUSH = 'brush';
exports.DRAWING_TOOL_TEXT = 'text';
exports.DRAWING_TOOL_PHOTO = 'photo';
exports.DRAWING_TOOL_LINK = 'link';
exports.DRAWING_TOOL_CIRCLE = 'circle';
exports.DRAWING_TOOL_CLOUD = 'cloud';
exports.DRAWING_TOOL_RECTANGLE = 'rectangle';
exports.CIRCLE = 'circle';
exports.PATH = 'path';
exports.TEXT = 'text';
exports.RECTANGLE = 'rectangle';
exports.CLOUD = 'cloud';
exports.TASK = 'task';
exports.BITMAP = 'bitmap';
exports.GROUP = 'group';
exports.H_OFFSETS = { start: 0, left: 0, center: -0.5, end: -1, right: -1 };
exports.V_OFFSETS = {
    top: 0,
    hanging: -0.01,
    middle: -0.5,
    alphabetic: -0.8,
    ideographic: -0.85,
    bottom: -1
};
